import { createFileRoute } from "@tanstack/react-router";
import { Organizations } from "@/components/Organizations";

function RouteComponent() {
  return <Organizations />;
}

export const Route = createFileRoute("/_authenticated/accounts/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
